module.exports = __webpack_public_path__ + "static/media/logo.8707a787.svg";